import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { get } from "lodash";

import Box from "@material-ui/core/Box";

import CustomButton from "../../Common/CustomButton";
import DatePicker from "../../Common/DatePicker";
import SitesFilter from "../SitesFilter";

import { formatDate, setToMidnight } from "../../../utils/date";

const styles = {
  gridLine: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 200px)",
    gridAutoRows: "56px",
    gridGap: "24px",
    padding: "24px",
  },
};

const HspCurrentStatusForm = (props) => {
  const { classes, search, isFetching, assignedSite } = props;
  const [filters, setFilters] = React.useState({
    date: setToMidnight(new Date()),
  });

  React.useEffect(() => {
    if (assignedSite) {
      setFilters({
        date: setToMidnight(new Date()),
        sites: assignedSite,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignedSite]);

  const handleChange = (id, index, value) => {
    setFilters(
      update(filters, {
        [id]: { $set: value },
      })
    );
  };

  return (
    <Box className={classes.gridLine}>
      <SitesFilter
        formValue={[get(filters, ["sites"]) || ""]}
        setFormValue={handleChange}
        defaultSelectAll={false}
        singleSelect
      />
      <Box>
        <DatePicker
          label={I18n.get("dashboard_date")}
          name="date"
          value={get(filters, ["date"])}
          onChange={(name, date) =>
            handleChange(name, null, setToMidnight(date))
          }
          width={200}
          formatLabel={(date) => formatDate(date, "MMMM Do")}
          dateOnly
        />
      </Box>
      <Box style={{ display: "flex", alignItems: "flex-end" }}>
        <CustomButton
          variant="contained"
          color="primary"
          onClick={() => search(filters)}
          disabled={isFetching}
        >
          {I18n.get("dashboard_search")}
        </CustomButton>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(HspCurrentStatusForm);
